import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta:{
      title: '华商科技-首页',
      keepAlive: false
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/index.vue'),
    meta:{
      title: '华商科技-关于华商',
      keepAlive: false
    }
  },
  {
    path: '/giveServiceTo',
    name: 'giveServiceTo',
    component: () => import('@/views/giveServiceTo/index.vue'),
    meta:{
      title: '华商科技-服务支持',
      keepAlive: false
    }
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: () => import('@/views/joinUs/index.vue'),
    meta:{
      title: '华商科技-加入我们',
      keepAlive: false
    }
  },
  {
    path:'/product',
    name:'product',
    component: () => import('@/views/product/index.vue'),
    meta:{
      title: '华商科技-产品与解决方案',
      keepAlive: false
    }
  }
 
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
